<template>
  <div :class="['register-card-main', registerClass]">
    <TipMessage ref="addfromtip" />
    <div class="re-head-line">
      <div class="re-title">完善信息</div>
      <div class="re-subtitle">方便我们为您提供更精准的服务</div>
    </div>

    <div class="re-form-container">
      <div class="re-form-item">
        <input
          type="text"
          v-model="addForm.username"
          class="re-input"
          placeholder="请输入您的用户名"
          maxlength="10"
          @input="usernameInput"
          @blur="usernameInputBlur"
        />
        <div class="re-form-item-tip">{{ formErrorTip["username"] }}</div>
      </div>
      <div class="re-form-item">
        <input
          type="password"
          v-model="addForm.PWD"
          class="re-input"
          placeholder="请设置密码"
          maxlength="30"
          @input="passInput"
          @blur="passInput"
        />
        <div class="re-form-item-tip">{{ formErrorTip["PWD"] }}</div>
      </div>
      <div class="re-form-item">
        <input
          type="password"
          maxlength="30"
          v-model="addForm.secondPassword"
          class="re-input"
          placeholder="请确认您的密码"
          @input="secondPassInput"
          @blur="secondPassInput"
        />
        <div class="re-form-item-tip">{{ formErrorTip["secondPassword"] }}</div>
      </div>
      <div class="re-form-item" v-if="userType === 1">
        <input
          type="text"
          v-model="addForm.company"
          class="re-input"
          placeholder="请输入您的公司名称"
          maxlength="20"
          @input="companyInput"
        />
        <div class="re-form-item-tip">{{ formErrorTip["company"] }}</div>
      </div>
      <div class="re-form-item" v-if="userType === 1">
        <input
          type="text"
          v-model="addForm.name"
          class="re-input"
          placeholder="请输入您的姓名"
          maxlength="10"
          @input="nameInput"
        />
        <div class="re-form-item-tip">{{ formErrorTip["name"] }}</div>
      </div>
      <div class="re-form-item form-select-line re-m-y-0">
        <select
          ref="main-select"
          class="form-select main-select"
          id="categoryParent"
          @change="handleMainSelect"
        >
          <!-- <option value="-1">
            <span class="first-option"> 您想要了解的产业 </span>
          </option> -->
          <option
            v-for="item in mainSelectList"
            :key="item.CategoryID"
            :value="item.CategoryID"
          >
            {{ item.CategoryName }}
          </option>
        </select>
        <select
          ref="sub-select"
          class="form-select sub-select"
          id="categoryID"
          @change="handleSubSelect"
        >
          <!-- <option value="-1">
            <span class="first-option"> 选择产业联盟 </span>
          </option> -->
          <option
            v-for="item in subSelectList"
            :key="item.CategoryID"
            :value="item.CategoryID"
          >
            {{ item.CategoryName }}
          </option>
        </select>
        <div class="re-form-item-b-l-tip">{{ formErrorTip["categoryID"] }}</div>
      </div>
      <div class="re-form-item re-m-y-0">
        <input
          class="re-submit"
          type="button"
          value="完成注册"
          @click="formSubmit"
        />
        <div v-show="isShowFin" class="re-finish-tip">
          请务必完善信息，完成注册
        </div>
      </div>
    </div>

    <div class="re-card-bottom-tip" :style="homeContainBS">
      <img
        class="bottom-tip-icon"
        src="../../assets/images/register/telephone.png"
        alt=""
      />

      客服热线：<a href="tel:18618300427" class="color-t333">18618300427</a>
    </div>
  </div>
</template>

<script>
import { validatePWD } from "@/utils/formValidate.js";
import { mapState, mapMutations } from "vuex";
import { getFatherIndustry, getChildIndustry } from "@/api/register.js";
import { userRegister, checkUsername } from "@/api/register.js";

export default {
  props: {},
  name: "AddForm",
  components: {},
  data() {
    return {
      routerFormType: null,
      mainSelectIsOpen: false,
      mainSelectList: [],
      subSelectIsOpen: false,
      subSelectList: [],
      addForm: {
        username: "",
        PWD: "",
        secondPassword: "",
        company: undefined,
        name: undefined,
        SourceID: undefined,
        //
        logName: undefined,
        /**
         * types 用户类型
         * 	1： 企业
         * 	2： 个人
         */
        types: 1,
        mobile: "",
        mobileSystem: 1,
        IPAdress: "",
        // 首选产业
        categoryParent: undefined,
        // 子产业
        categoryID: undefined,
      },
      defaultErrorTip: {
        username: ["仅支持输入英文或数字组合", "用户名已存在"],
        PWD: "请输入有效密码",
        secondPassword: "输入密码不一致",
        company: "请输入有效公司名称",
        name: "请输入有效姓名",
        categoryParent: "请选择企业",
        categoryID: "请选择产业联盟",
      },
      formErrorTip: {
        username: "",
        PWD: "",
        secondPassword: "",
        company: "",
        name: "",
        // 首选产业
        categoryParent: "",
        // 子产业
        categoryID: "",
      },
      tuiguangIds: {
        1: {
          value: 1,
          name: "百度推广链接",
        },
        0: {
          value: 0,
          name: "网站",
        },
        6: {
          value: 6,
          name: "编辑号注册",
        },
      },
      userType: 2,
      // 是否点击 mask
      isClickMask: false,
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
      userIp: (state) => state.user.userIp,
      userMobile: (state) => state.user.mobile,
      userToken: (state) => state.user.token,
      logname: (state) => state.user.logname,
      sourceId: (state) => state.user.sourceId,
    }),
    isShowFin() {
      if (this.userPlatform === 2 && this.isClickMask) {
        return true;
      }
      return false;
    },
    registerClass() {
      if (this.userPlatform === 2) {
        return "login-card-windows-main";
      }
      return "";
    },
    homeContainBS() {
      if (this.$store.state.user.userPlatform === 0) {
        return {
          position: "fixed",
          bottom: "2em",
        };
      }
      return {
        position: "absolute",
      };
    },
  },
  watch: {
    "$route.query.userType": {
      handler(v) {
        if (!v) {
          const currentQuery = this.$route.query;

          this.$router.push({
            path: this.$route.path,
            query: {
              ...currentQuery,
              formType: undefined,
              userType: this.userType,
            },
          });
        } else {
          this.initUserType();
        }
      },
      immediate: true,
    },
    "$route.query.formType": {
      handler(v) {
        const query = this.$route.query;
        query.formType = "";
        let queryStr = "";
        for (const key in query) {
          if (Object.hasOwnProperty.call(query, key)) {
            const element = query[key];
            queryStr += `${key}=${element}&`;
          }
        }
        if (
          this.routerFormType === "registerSuccess" &&
          v !== "registerSuccess"
        ) {
          sessionStorage.clear();
          location.href = "/?" + queryStr;
        }
        this.routerFormType = v;
      },
    },
  },
  mounted() {
    this.initBaseInfo();
    this.initMainSelect();
  },
  methods: {
    ...mapMutations("user", ["setUserMobile"]),
    initUserType() {
      const currentQuery = this.$route.query;
      const userType = parseInt(currentQuery["userType"]) || this.userType;
      this.userType = userType;
      this.addForm.types = userType;
    },
    async formSubmit() {
      const requestInfo = this.getFormValue();
      let validateFormRes = this.validateForm();
      let valUsernameRes = await this.usernameInputBlur();

      if (!validateFormRes || !requestInfo || valUsernameRes === 1) {
        return;
      }
      userRegister({
        ...requestInfo,
        secondPassword: undefined,
        categoryParent: undefined,
      }).then((response) => {
        /**
         *  <0  注册失败
         *  0   已经注册
         *  >0  注册成功
         */
        this.setUserMobile("");

        const code = parseInt(response);
        if (code < 0) {
          // 注册失败
          this.$refs["addfromtip"].showMessage({
            msg: "注册失败",
            msgType: "error",
          });
        }
        if (code === 0) {
          this.$refs["addfromtip"].showMessage({
            msg: "该账号已经注册",
            msgType: "warning",
          });

          // const currentQuery = this.$route.query;
          // this.$router.push({
          //   path: this.$route.path,
          //   query: {
          //     ...currentQuery,
          //     formType: "rgisterSuccess",
          //   },
          // });
        }
        if (code > 0) {
          // 注册成功
          const currentQuery = this.$route.query;
          this.$router.push({
            path: this.$route.path,
            query: {
              ...currentQuery,
              formType: "registerSuccess",
            },
          });
        }
      });
    },
    handleErrorForm() {
      this.$refs["addfromtip"].showMessage({
        msg: "信息丢失",
        msgType: "error",
      });
      return false;
    },
    // 对于 注册页传递过来的数据，进行初始化
    initBaseInfo() {
      const defaultIP = '117.122.241.235'
      if (this.userPlatform || this.userPlatform === 0) {
        this.addForm.mobileSystem = this.userPlatform;
      }
      if (this.userIp || this.userIp === 0) {
        this.addForm.IPAdress = this.userIp;
        this.addForm.IPAdress = this.addForm.IPAdress ? this.addForm.IPAdress : defaultIP
      }
    },
    /**校验表单是否存在错误 */
    validateForm() {
      this.usernameInput();
      this.passInput();
      this.secondPassInput();
      if (this.userType == 1) {
        this.companyInput();
        this.nameInput();
      }
      this.subSelectValidate();
      this.mainSelectValidate();
      let formHasError = false;
      // 校验表单错误提示中 是否依然存在 错误提示
      for (const key in this.formErrorTip) {
        if (Object.hasOwnProperty.call(this.formErrorTip, key)) {
          const element = this.formErrorTip[key];
          if (!formHasError) {
            if (element) {
              formHasError = true;
            }
          }
        }
      }
      if (formHasError) {
        return false;
      }
      return true;
    },
    getFormValue() {
      this.initBaseInfo();
      const requestInfo = this.addForm;

      let logname = this.logname;
      let sourceId = this.sourceId;
      // logname =  logname * 123 - 456 + 678
      // ( 获取的logname 是真实的 logname 进行了运算了的 )
      // 使用运算进行转换
      if (logname) {
        this.addForm.logName = parseInt(logname);
      }
      if (sourceId || sourceId == 0) {
        this.addForm.SourceID = parseInt(sourceId);
      } else {
        return this.handleErrorForm();
      }

      if (this.userMobile) {
        this.addForm.mobile = this.userMobile;
      }
      // secondPassword  不需要 确认密码时 输入的密码
      let { logName, types, mobile, mobileSystem, IPAdress, SourceID } =
        this.addForm;
      if (
        !(
          (SourceID || SourceID == 0) &&
          types &&
          mobile &&
          (mobileSystem || mobileSystem === 0) &&
          IPAdress
        )
      ) {
        return this.handleErrorForm();
      } else {
        if (SourceID === 6 && !logName) {
          return this.handleErrorForm();
        }

        if (SourceID !== 6 && logName) {
          return this.handleErrorForm();
        }
      }

      return requestInfo;
    },

    initMainSelect() {
      getFatherIndustry().then((res) => {
        if (res && res.length) {
          this.mainSelectList = res;
          this.addForm.categoryParent = this.mainSelectList[0]['CategoryID']
          this.getSubSelect()
        }
      });
    },
    getSubSelect() {
      getChildIndustry({
        parentID: this.addForm.categoryParent,
      }).then((res) => {
        if (res && res.length) {
          this.subSelectList = res;
          this.addForm.categoryID= this.subSelectList[0]['CategoryID']
        }
      });
    },
    handleMainSelect() {
      let mainSelectDom = document.getElementById("categoryParent");

      let optionChecked = mainSelectDom.querySelector("option:checked");
      let checkedId =
        optionChecked && parseInt(optionChecked.getAttribute("value"));
      let firefoxV = mainSelectDom.options[mainSelectDom.selectedIndex].value;

      checkedId = checkedId ? checkedId : firefoxV;
      this.mainSelectIsOpen = !this.mainSelectIsOpen;

      if (checkedId !== this.addForm.categoryParent) {
        // if (checkedId > -1 && checkedId !== this.addForm.categoryParent) {
        this.addForm.categoryParent = checkedId;
        this.getSubSelect();
        this.addForm.categoryID = "";
      }
      this.mainSelectValidate();
    },
    handleSubSelect() {
      let mainSelectDom = document.getElementById("categoryID");
      let optionChecked = mainSelectDom.querySelector("option:checked");
      let checkedId =
        optionChecked && parseInt(optionChecked.getAttribute("value"));
      let firefoxV = mainSelectDom.options[mainSelectDom.selectedIndex].value;
      checkedId = checkedId ? checkedId : firefoxV;
      this.subSelectIsOpen = !this.subSelectIsOpen;

      if (checkedId) {
        // if (checkedId > -1) {
        this.addForm.categoryID = checkedId;
      }
      this.subSelectValidate();
    },
    // changeMainSelFirText(errorText) {
    //   let mainSelectDom = document.getElementById("categoryParent");
    //   const defaultText = "您想要了解的产业";
    //   if (mainSelectDom && errorText) {
    //     mainSelectDom.style.color = "#f00";
    //     return errorText;
    //   }
    //   mainSelectDom.style.color = "#333";

    //   return defaultText;
    // },
    // changeSubSelFirText(errorText) {
    //   let mainSelectDom = document.getElementById("categoryID");
    //   const defaultText = "选择产业联盟";
    //   if (mainSelectDom && errorText) {
    //     mainSelectDom.style.color = "#f00";
    //     return errorText;
    //   }
    //   mainSelectDom.style.color = "#333";
    //   return defaultText;
    // },
    mainSelectValidate() {
      if (!this.addForm.categoryParent || this.addForm.categoryParent <= -1) {
        this.formErrorTip["categoryParent"] = "请选择产业";
      } else {
        this.formErrorTip["categoryParent"] = "";
      }
      // this.changeMainSelFirText(
      //   this.formErrorTip["categoryParent"]
      // );
    },
    subSelectValidate() {
      if (!this.addForm.categoryID || this.addForm.categoryID <= -1) {
        this.formErrorTip["categoryID"] = "请选择了解的产业和产业联盟";
      } else {
        this.formErrorTip["categoryID"] = "";
      }
      // this.changeSubSelFirText(
      //   this.formErrorTip["categoryID"]
      // );
    },
    usernameInput() {
      const reg = /^[A-Za-z0-9]+$/;
      if (reg.test(this.addForm.username)) {
        this.formErrorTip["username"] = "";
        return true;
      } else {
        this.formErrorTip["username"] = "仅支持输入英文或数字组合";
        return false;
      }
    },
    async usernameInputBlur() {
      let valiUsernameRes = this.usernameInput();
      if (!valiUsernameRes) {
        return 1;
      }
      let res = await this.checkUserName();
      if (res === 1) {
        // 已经注册
        this.formErrorTip["username"] = "该用户名已经注册";
      } else {
        this.formErrorTip["username"] = "";
      }

      return res;
    },
    checkUserName() {
      let that = this;

      /*
					-1 校验失败
					0  从未注册
					1		已经注册
				*/
      return new Promise((resolve) => {
        checkUsername({
          UserName: that.addForm.username,
        })
          .then((response) => {
            let resdata = parseInt(response);
            if (resdata === 1) {
              // 已经注册过
              return resolve(1);
            } else {
              return resolve(0);
            }
          })
          .finally(() => {
            return resolve(1);
          });
      });
    },
    passInput() {
      let validateRes = validatePWD(this.addForm.PWD);
      let pwd = this.addForm.PWD.trim();
      let pwdLength = pwd.length;
      const minLength = 6;
      if (pwdLength < minLength) {
        this.formErrorTip["PWD"] = "至少输入6位字符";
        return;
      }

      if (!pwd) {
        this.formErrorTip["PWD"] = "请设置密码";
        return;
      }
      if (validateRes) {
        this.formErrorTip["PWD"] = "";
      } else {
        this.formErrorTip["PWD"] = "请使用英文字母加数字或符号的组合密码";
      }
    },
    secondPassInput() {
      let secondPwd = this.addForm.secondPassword.trim();
      let firstPwd = this.addForm.PWD.trim();
      if (secondPwd !== firstPwd) {
        this.formErrorTip["secondPassword"] = "两次输入密码不一致";
        return false;
      }
      this.formErrorTip["secondPassword"] = "";
      return true;
    },

    companyInput() {
      if (!this.addForm.company) {
        this.formErrorTip["company"] = "请输入您的公司名称";
      } else {
        this.formErrorTip["company"] = "";
      }
    },
    nameInput() {
      if (!this.addForm.name) {
        this.formErrorTip["name"] = "请输入您的姓名";
      } else {
        this.formErrorTip["name"] = "";
      }
    },
    handleMask() {
      this.isClickMask = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.register-card-main {
  box-sizing: border-box;
  position: relative;
  flex-basis: 1;
  flex-grow: 1;
  // padding: 20px 10px;
  .re-head-line {
    display: flex;
    align-items: center;
    height: 0;
    overflow: hidden;
    padding: 0 10px;
    margin-bottom: 10px;
    .re-title {
      display: inline-block;
      font-size: 22px;

      font-weight: 500;
      color: #333333;
    }
    .re-subtitle {
      padding-left: 1rem;
      display: inline-block;

      font-weight: 400;
      color: #333333;
    }
  }

  .re-form-container {
    position: relative;
    top: -100px;
    background-color: #ffffff;
    padding: 10px;

    .re-form-item {
      position: relative;
      color: #333333;
      margin-bottom: 10px;

      .re-input {
        width: 100%;
        // width: 356px;
        height: 44px;
        border: 1px solid #e4e5eb;
        padding: 10px;
        &::placeholder {
          color: #c0c4cc;
        }
      }
      .re-form-item-tip {
        position: absolute;
        // bottom: -20px;
        // left: 3rem;
        right: 2em;
        bottom: 10px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #ff0000;
      }

      .re-form-item-b-tip,
      .re-form-item-b-l-tip {
        position: absolute;
        left: 3rem;
        bottom: -1.5rem;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #ff0000;
      }
      .re-form-item-b-l-tip {
        left: 0.5rem;
      }
      .re-submit {
        margin: 22px 0;
        width: 100%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #2b304d;
        color: #ffffff;
        border: none;
        cursor: pointer;
      }
      .re-finish-tip {
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 100%;
        color: #ff0000;
        text-align: center;
        font-size: 12px;
        height: 2em;
        line-height: 2em;
      }
    }
    .re-m-y-0 {
      margin-top: 0;
      margin-bottom: 0;
    }
    .form-select-line {
      display: flex;
      justify-content: space-between;
      font-size: 0.9em;
      .main-select {
        flex-basis: 1;
        // flex-grow: 2;
        min-width: 49%;
      }
      .sub-select {
        flex-basis: 1;
        // flex-grow: 1;
        min-width: 49%;
        margin-left: 2%;
      }
      .form-select {
        border: 1px solid #e4e5eb;
        height: 44px;
        line-height: 40px;
        padding: 0 0.5rem;
        color: #666666;
      }

      .form-select:focus {
        outline: none;
      }

      .form-select::-ms-expand {
        background-color: #ffffff;
        border: none;
      }
    }
  }

  .re-card-bottom-tip {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #f5f6f9;
    height: 40px;

    text-align: center;

    font-size: 12px;
    font-weight: 400;
    color: #333333;
    .bottom-tip-icon {
      width: 1.2em;
      height: 1.2em;
      object-fit: cover;
      margin-right: 1em;
    }
  }
}
.login-card-windows-main {
  padding: 40px 50px;
  .re-head-line {
    height: auto;
  }
  .re-form-container {
    position: relative;
    top: 0;
    .re-form-item {
      margin-bottom: 10px;
      .re-submit {
        margin: 30px 0 20px;
      }
    }
    .re-m-y-0 {
      margin-top: 0;
      margin-bottom: 0;
    }
    .re-card-bottom-tip {
      position: absolute;
    }
  }
}
</style>